import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Service from './edit-last-plan.service'
import Form from './form.component'
import FormHelper from '../../../../../../utils/FormHelper'
import './edit-last-plan.styles.scss'
import Dialog from '../../../../../../components/dialog/dialog.component'
import Loading from '../../../../../../components/loading/loading.component'

class EditLastPlan extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.save()
    }

    render() {
        return (
            <div className="edit-plan card">
                {this.state.saving && <Dialog><Loading /></Dialog>}
                <div className="header">
                    <h4>Make Active</h4>
                </div>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                <Form {...this.state} onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.props.onClose}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(EditLastPlan))